import { PartnerType } from '@retailer-platform/dashboard/utils'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

// View gate — every retailer is opted in by default (partner-type gate, no per-role
// permission grant). Tenant isolation comes from Mesh resource scoping, not this gate.
export const retailerContactViewAccessControl: DomainAccessControlConfig = {
  partnerTypes: [PartnerType.Retailer],
}

// Modify gate — Mesh re-checks `retailer_contact_management.modify` on every mutation,
// so this only controls the UI affordances.
export const retailerContactModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.RetailerContactManagementModify],
}
